import SessionStorage from './SessionStorage.js';

export default class OvsPreviousStep extends SessionStorage {
  static get key() {
    return 'ovs-previous-step';
  }
}
